import { useState } from 'react';
import MinusIcon from '../Icons/MinusIcon';
import AddIcon from '../Icons/AddIcon';

interface AccordionSpesificationNewCarPurchaseProps {
  title: string;
  iconTitle?: React.ReactNode;
  children: React.ReactNode;
  index: string;
  classTitle?: string;
  rightSection?: () => React.ReactNode;
  customComponent?: () => React.ReactNode;
  from?: string;
  className?: string;
}

const AccordionSpesificationNewCarPurchase = ({
  iconTitle,
  children,
  rightSection = () => <></>,
  customComponent,
  title = '',
  classTitle = '',
  index = '',
  className = '',
}: AccordionSpesificationNewCarPurchaseProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <button
      className={`block w-full ${!isOpen ? 'border-b border-reliableBlack10' : 'relative'} ${className}`}
      type="button"
    >
      <details className={`py-[18px] lg:px-5`}>
        <summary
          className={`flex justify-start items-center -my-[18px] py-[13px] md:py-[18px] text-sm text-start font-medium text-reliableBlack cursor-pointer lg:text-base relative`}
          onClick={() => setIsOpen(!isOpen)}
        >
          {/* <div className=" absolute w-full" /> */}
          <div className="w-full flex justify-between items-center">
            <div id="branch-faq" className="flex justify-between items-center w-full">
              <h3 className={`question-${index} ${classTitle}`}>
                {iconTitle}
                {title}
              </h3>
              <span className="ml-4 pointer-events-none">
                {isOpen ? <MinusIcon /> : <AddIcon />}
              </span>
            </div>
            {rightSection ? rightSection() : null}
          </div>
        </summary>
        {isOpen && (
          <div className="border-t border-reliableBlack10 absolute w-full -left-0 -mt-2" />
        )}
        <div
          className={`text-start font-normal text-reliableBlack leading-relaxed lg:leading-relaxed relative`}
        >
          <div className={`answer-${index}`}>
            {customComponent ? (
              customComponent()
            ) : (
              <div
                className="prose max-w-none !text-sm lg:!text-base"
                dangerouslySetInnerHTML={{ __html: children }}
              />
            )}
          </div>
        </div>
      </details>
    </button>
  );
};

export default AccordionSpesificationNewCarPurchase;
